/**
 * <product-card-countdown> — Cuenta regresiva compacta para product cards de coleccion.
 *
 * Lee `data-target-ts` (unix en segundos) y actualiza dias / horas / minutos / segundos
 * cada 1s. Cuando expira, remueve el elemento del DOM para no dejar un "00:00:00"
 * en la card. No recarga la pagina (a diferencia de countdown-420), porque varias
 * cards pueden expirar en paralelo.
 */
(function () {
  if (customElements.get('product-card-countdown')) return;

  class ProductCardCountdown extends HTMLElement {
    constructor() {
      super();
      this._tick = this._tick.bind(this);
      this._intervalId = null;
    }

    connectedCallback() {
      const raw = this.getAttribute('data-target-ts');
      const targetSec = parseInt(raw, 10);

      if (!targetSec || Number.isNaN(targetSec)) {
        this.remove();
        return;
      }

      this._targetMs = targetSec * 1000;
      this._values = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };

      this._tick();
      if (!this.isConnected) return;
      this._intervalId = window.setInterval(this._tick, 1000);
    }

    disconnectedCallback() {
      if (this._intervalId) {
        window.clearInterval(this._intervalId);
        this._intervalId = null;
      }
    }

    _tick() {
      const diffMs = this._targetMs - Date.now();

      if (diffMs <= 0) {
        this.dispatchEvent(
          new CustomEvent('countdown:expired', { bubbles: true, composed: true })
        );
        this.remove();
        return;
      }

      const totalSec = Math.floor(diffMs / 1000);
      const days = Math.floor(totalSec / 86400);
      let hours = Math.floor((totalSec % 86400) / 3600);
      const minutes = Math.floor((totalSec % 3600) / 60);
      const seconds = totalSec % 60;

      // Si no se muestra la unidad de dias, acumulamos los dias restantes en las horas
      // para no perder tiempo (p. ej. 1d 03h -> 27h).
      if (!this._values.days) {
        hours += days * 24;
      }

      this._set(this._values.days, days);
      this._set(this._values.hours, hours);
      this._set(this._values.minutes, minutes);
      this._set(this._values.seconds, seconds);
    }

    _set(el, value) {
      if (!el) return;
      const padded = String(value).padStart(2, '0');
      if (el.textContent !== padded) {
        el.textContent = padded;
      }
    }
  }

  customElements.define('product-card-countdown', ProductCardCountdown);
})();
